var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"pa-0 white--text"},[_c('v-row',{staticClass:"fill-height my-3",attrs:{"justify":"center"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }